/**
 * Translation keys for the /reviews page. Mirrors keys defined in the
 * `reviewsPage` namespace inside `messages/*.json`.
 */
export const reviewsPageKeys = {
  heroEyebrow: "heroEyebrow",
  heroHeading: "heroHeading",
  heroLeadIn: "heroLeadIn",
  heroSubtitle: "heroSubtitle",
  heroCtaPrimary: "heroCtaPrimary",
  heroCtaSecondary: "heroCtaSecondary",

  // Press / featured-in strip
  pressEyebrow: "pressEyebrow",

  // Outcome stat (under the trust strip)
  outcomeStat: "outcomeStat",

  // Themes section ("Three things people mention")
  themesEyebrow: "themesEyebrow",
  themesHeading: "themesHeading",
  themesSocialProof: "themesSocialProof",
  themeClarityTitle: "themeClarityTitle",
  themeClarityDesc: "themeClarityDesc",
  themeSpeedTitle: "themeSpeedTitle",
  themeSpeedDesc: "themeSpeedDesc",
  themeDoctorTitle: "themeDoctorTitle",
  themeDoctorDesc: "themeDoctorDesc",
  themeExperienceTitle: "themeExperienceTitle",
  themeExperienceDesc: "themeExperienceDesc",
  themeReturnTitle: "themeReturnTitle",
  themeReturnDesc: "themeReturnDesc",

  // Trust strip
  trustGoogleLabel: "trustGoogleLabel",
  trustTrustpilotLabel: "trustTrustpilotLabel",
  trustMembersLabel: "trustMembersLabel",
  trustNpsLabel: "trustNpsLabel",
  trustReviewsLabel: "trustReviewsLabel",
  trustAllFiveStarLabel: "trustAllFiveStarLabel",

  // Section headings
  storiesHeading: "storiesHeading",
  storiesSubtitle: "storiesSubtitle",
  videosHeading: "videosHeading",
  videosSubtitle: "videosSubtitle",
  expertsHeading: "expertsHeading",
  expertsSubtitle: "expertsSubtitle",

  // Source filter labels
  filterAll: "filterAll",
  filterGoogle: "filterGoogle",
  filterTrustpilot: "filterTrustpilot",

  // FAQ
  faqHeading: "faqHeading",

  // Ambassadors invitation
  ambassadorsEyebrow: "ambassadorsEyebrow",
  ambassadorsHeading: "ambassadorsHeading",
  ambassadorsBody: "ambassadorsBody",
  ambassadorsCta: "ambassadorsCta",

  // "Share your experience" card at the end of the review bento.
  // Rendered as two stacked text lines under the Google "G" logo:
  // <line1> (smaller) / <line2> (display-sized). The whole card links
  // to Google's writereview URL.
  shareReviewHeading: "shareReviewHeading",
  shareReviewBody: "shareReviewBody",
  shareReviewCta: "shareReviewCta",
  shareReviewLine1: "shareReviewLine1",
  shareReviewLine2: "shareReviewLine2",

  // CTA banner
  ctaHeading: "ctaHeading",
  ctaSubtitle: "ctaSubtitle",
  ctaPrimary: "ctaPrimary",
  ctaSecondary: "ctaSecondary",

  // Footer microcopy
  externalNote: "externalNote",

  // Translation badge tooltips (rendered next to translated review titles).
  translatedFromEn: "translatedFromEn",
  translatedFromDe: "translatedFromDe",
} as const
